import React, { useState, useRef, useEffect } from "react"
import InputField from "../Input"
import { FaSearch } from "react-icons/fa"

const SearchAirportsDropDown = ({
  sortedAirports,
  placeholder,
  value,
  fieldName,
  setFieldValue,
  className,
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const [search, setSearch] = useState("")
  const wrapperRef = useRef(null)

  const displayValue = isOpen ? search : value

  const filteredAirports =
    search.trim() === ""
      ? sortedAirports
      : sortedAirports.filter((airport) =>
          `${airport.city} ${airport.country} ${airport.airport} ${airport.code}`
            .toLowerCase()
            .includes(search.toLowerCase())
        )

  const handleSelect = (airport) => {
    const selectedValue = `${airport.city}, ${airport.country} - ${airport.airport}`
    setIsOpen(false)
    setFieldValue(fieldName, selectedValue)
    setSearch("")
  }

  const handleClickOutside = (event) => {
    if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
      setIsOpen(false)
      setSearch("")
    }
  }

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside)
    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [])

  return (
    <div ref={wrapperRef} className="relative w-full">
      <div className="relative">
        <InputField
          type="text"
          placeholder={placeholder}
          value={displayValue}
          onFocus={() => setIsOpen(true)}
          onChange={(e) => {
            setSearch(e.target.value)
            setIsOpen(true)
          }}
          className={`bg-white !px-0 ${className}`}
        />
        {!value && (
          <FaSearch className="w-4 h-4 absolute right-2 top-1/2 transform -translate-y-1/2 " />
        )}
      </div>

      {isOpen && (
        <ul className="absolute z-10 mt-1 w-full bg-white shadow-lg max-h-60 overflow-auto rounded-md divide-y-[0.07rem] ">
          {filteredAirports.length > 0 ? (
            filteredAirports.map((airport, index) => (
              <li
                key={index}
                className="flex justify-between items-center cursor-pointer select-none relative p-4 hover:bg-gray-100"
                onClick={() => handleSelect(airport)}
              >
                <div>
                  <p className="font-semibold">
                    {airport.city}, {airport.country}
                  </p>
                  <p className="text-sm text-gray-500">{airport.airport}</p>
                </div>
                <div className="bg-blue-100 text-blue-800 px-2 py-1 rounded-md text-sm">
                  {airport.code}
                </div>
              </li>
            ))
          ) : (
            <li className="p-4 text-gray-500">No airports found.</li>
          )}
        </ul>
      )}
    </div>
  )
}

export default SearchAirportsDropDown
